'use es6';

import enviro from 'enviro';
import { isHubSpotter, isForceOpen } from './utils';
export const earlyCheck = () => {
  if (isForceOpen()) {
    return true;
  }
  if (enviro.getShort() === 'qa') {
    return false;
  }
  return true;
};
export const fullCheck = userData => {
  const {
    userEmail = ''
  } = userData || {};
  const isProd = enviro.getShort() === 'prod';
  if (isForceOpen()) {
    return true;
  }
  if (isProd) {
    if (isHubSpotter(userEmail)) {
      return false;
    }
    return true;
  }
  return false;
};